export const SELECT_STYLES = {
  trigger: [
    'bg-zinc-700',
    'border-zinc-600',
    'hover:border-zinc-500',
    'focus:border-amber-400',
    'data-[hover=true]:border-zinc-500',
    'data-[open=true]:border-amber-400',
    'data-[focus=true]:border-amber-400',
    '!cursor-pointer',
    '!rounded-lg',
    'text-white',
    'data-[hover=true]:bg-zinc-700',
    'min-h-[44px]',
    'h-[44px]',
    'flex',
    'items-center',
    'pl-10',
    'pr-3',
    'relative',
  ],
  value: ['text-white', 'font-normal', 'flex-1', 'text-left'],
  selectorIcon: [
    'text-zinc-400',
    'w-5',
    'h-5',
    'flex-shrink-0',
    'absolute',
    'left-3',
    'top-1/2',
    '-translate-y-1/2',
  ],
  popoverContent: ['bg-zinc-700', 'border-zinc-600', 'rounded-lg', '!w-full', 'min-w-full'],
  base: ['!p-0', '!m-0'],
  mainWrapper: ['!h-[44px]'],
  innerWrapper: ['!h-full', 'flex', 'items-center', 'justify-between', 'px-0'],
};

export const OPTION_STYLES = {
  default:
    'text-white data-[hover=true]:bg-zinc-600 data-[hover=true]:rounded-lg data-[selected=true]:bg-amber-400 data-[selected=true]:rounded-lg',
  loader: 'text-white hover:bg-transparent cursor-default',
};

export const DEFAULT_LOAD_MORE_THRESHOLD = 2;
export const DEFAULT_ROOT_MARGIN = '100px';
export const LOADER_KEY = '__loader__';
